import {
  Form,
  Input,
  InputNumber,
  Select,
  Space,
  Checkbox,
  DatePicker,
} from "antd";
import WrappingModal from "../../../components/Modals/WrappingModal";

interface Props {
  form: any;
  isEditing: boolean;
  isModalOpen: boolean;
  handleOk: (values: any) => void;
  handleCancel: () => void;
  initialValues?: any;
  loading: boolean;
  accounts: any[];
  currencies: any[];
}

const FormModal = ({
  form,
  isEditing,
  isModalOpen,
  handleOk,
  handleCancel,
  initialValues,
  loading,
  accounts,
  currencies,
}: Props) => {
  return (
    <WrappingModal
      form={form}
      handleCancel={handleCancel}
      loading={loading}
      isModalOpen={isModalOpen}
      title={isEditing ? "تعديل مورد" : "إضافة مورد"}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        onFinish={handleOk}
      >
        <Space direction="vertical" className="w-full" size="large">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {isEditing && (
              <Form.Item name="VendorID" label="كود المورد">
                <InputNumber
                  placeholder="كود المورد"
                  className="w-full"
                  disabled
                />
              </Form.Item>
            )}
            <Form.Item
              name="VendorName"
              label="اسم المورد"
              rules={[{ required: true, message: "الرجاء إدخال اسم المورد" }]}
            >
              <Input placeholder="اسم المورد" className="w-full" />
            </Form.Item>
            <Form.Item
              name="VendorTypeID"
              label="نوع المورد"
              rules={[{ required: true, message: "الرجاء تحديد نوع المورد" }]}
            >
              <InputNumber className="w-full" placeholder="نوع المورد" />
            </Form.Item>
            <Form.Item name="Address" label="العنوان">
              <Input placeholder="العنوان" className="w-full" />
            </Form.Item>
            <Form.Item name="Phone" label="الهاتف">
              <Input placeholder="الهاتف" className="w-full" />
            </Form.Item>
            <Form.Item name="Mobail" label="الموبايل">
              <Input placeholder="الموبايل" className="w-full" />
            </Form.Item>
            <Form.Item name="Fax" label="الفاكس">
              <Input placeholder="الفاكس" className="w-full" />
            </Form.Item>
            <Form.Item name="CreditLimit" label="حد الائتمان">
              <InputNumber className="w-full" placeholder="حد الائتمان" />
            </Form.Item>
            <Form.Item name="CreditLimitPeriod" label="مدة حد الائتمان">
              <InputNumber className="w-full" placeholder="مدة حد الائتمان" />
            </Form.Item>
            <Form.Item name="CurrId" label="العملة">
              <Select placeholder="اختر العملة" className="w-full">
                {currencies.map((account) => (
                  <Select.Option key={account.CurrId} value={account.CurrId}>
                    {account.CurrName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="FirstBalDate" label="تاريخ الرصيد الأولي">
              <DatePicker
                className="w-full"
                placeholder="تاريخ الرصيد الأولي"
              />
            </Form.Item>
            <Form.Item name="FirstBal" label="الرصيد الأولي">
              <InputNumber className="w-full" placeholder="الرصيد الأولي" />
            </Form.Item>
            <div className="col-span-1 md:col-span-2 lg:col-span-3 flex flex-wrap gap-4">
              <Form.Item name="IsDebit" valuePropName="checked">
                <Checkbox>مدين</Checkbox>
              </Form.Item>
              <Form.Item name="IsCredit" valuePropName="checked">
                <Checkbox>دائن</Checkbox>
              </Form.Item>
              <Form.Item name="IsStoped" valuePropName="checked">
                <Checkbox>متوقف</Checkbox>
              </Form.Item>
            </div>
            <Form.Item name="TaxCrad" label="بطاقة ضريبية">
              <Input placeholder="بطاقة ضريبية" className="w-full" />
            </Form.Item>
            <Form.Item name="TaxNo" label="الرقم الضريبي">
              <Input placeholder="الرقم الضريبي" className="w-full" />
            </Form.Item>
            <Form.Item
              name="AccId"
              label="معرف الحساب"
              rules={[{ required: true, message: "الرجاء اختيار معرف الحساب" }]}
            >
              <Select placeholder="اختر معرف الحساب" className="w-full">
                {accounts.map((account) => (
                  <Select.Option key={account.AccID} value={account.AccID}>
                    {account.AccName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        </Space>
      </Form>
    </WrappingModal>
  );
};

export default FormModal;
